module.exports = __webpack_public_path__ + "static/media/Back_3.726f7f2d.jpg";